<div class="body">
  @if (detalleSolcitud) {
    <div class="container pt-3">
      <div class="row">
        <div class="col-12 col-sm-3 text-start">
          <h4>INFORMACIÓN DE LA SOLICITUD</h4>
        </div>
        <div class="col-12 col-sm-3 text-right">
          <span style="font-size: 45px"><i class="far fa-check-circle"></i></span>
        </div>
        <div class="col-12 col-sm-6 text-start">
          <h4>¿SEGURO QUE DESEAS CONFIRMAR LA NEGACIÓN DE LA SOLICITUD DE ESTE CLIENTE?</h4>
        </div>
      </div>
      <div class="row justify-content-md-center mt-4">
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            No. de Solicitud
          </div>
          <p>{{detalleSolcitud.solicitud.idSolicitud}}</p>
        </div>
        <div class="col-12 col-sm-6">
          <div class="header-inf">
            Nombre del solicitante
          </div>
          <p>{{detalleSolcitud.empresario.primerNombre}} {{detalleSolcitud.empresario.primerApellido}}</p>
        </div>
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            Monto solicitado
          </div>
          <p>{{detalleSolcitud.solicitud.monto | currency:'USD' : 'symbol' : '1.0-0'}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            Tipo de Identificación
          </div>
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 1) {
            <p>NIT</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 2) {
            <p>CÉDULA DE CIUDADANÍA</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 3) {
            <p>CÉDULA DE EXTRANJERÍA</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 4) {
            <p>TARJETA DE IDENTIDAD</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 5) {
            <p>PASAPORTE</p>
          }
          @if (detalleSolcitud.empresario.idTipoDocIdentidad_NeoTipoDocIdentidad == 6) {
            <p>NÚMERO ÚNICO DE IDENTIFICACIÓN</p>
          }
        </div>
        <div class="col-12 col-sm-6">
          <div class="header-inf">
            Número de identificación
          </div>
          <p>{{detalleSolcitud.empresario.numeroDocumento}}</p>
        </div>
        <div class="col-12 col-sm-3">
          <div class="header-inf">
            Plazo solicitado (meses)
          </div>
          <p>{{detalleSolcitud.solicitud.plazo}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12">
          <div class="header-inf">
            Destino del crédito
          </div>
          <p>{{detalleSolcitud.solicitud.destino}}</p>
        </div>
      </div>
      <div class="row justify-content-md-center mt-4">
        <div class="col-12 col-sm-12">
          <div class="header-inf">
            Número de Solicitud
          </div>
          <p>{{detalleSolcitud.solicitud.idSolicitud}}</p>
        </div>
      </div>
      <div class="row justify-content-center text-center mt-4">
        <div class="col-12 col-md-8">
          <p class="fw-semibold">Motivo de la negación</p>
          <textarea class="form-control text-center" rows="3" disabled>{{ detalleSolcitud.negacion.nombre }}</textarea>
        </div>
        @if (detalleSolcitud.observacionesNegacion != '') {
          <div class="col-12 col-md-8 mt-4">
            <p class="fw-semibold">Observaciones</p>
            <textarea class="form-control text-center" rows="3" disabled>{{ detalleSolcitud.observacionesNegacion }}</textarea>
          </div>
        }
      </div>
      <div class="row justify-content-md-center mt-4">
        <div class="col-12 col-sm-3">
          <button class="btn btn-primary" (click)="confirmarNegacion()">Confirmar negación</button>
        </div>
        <div class="col-12 col-sm-2">
          <button class="btn btn-primary" (click)="cancelar()">Volver</button>
        </div>
      </div>
    </div>
  }
  <div class="footer-body"></div>
</div>

<!-- Modal -->
<div class="modal fade text-center" id="aceptarModal" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body-monto justify-content-md-center">
        <div class="row">
          <div class="col-12 col-sm-11 me-3 ms-3">
            <h3>La confirmación de la negación ha sido realizada correctamente</h3>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-md-center">
        <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
      </div>
    </div>
  </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
